import styled from 'styled-components';
import { BaseMessage } from './BaseMessage';

export const WarningMessage = styled(BaseMessage)`
  background: #e89d3b;
  color: #fff;
`;
